export default __webpack_public_path__ + "static/media/loading.36c54cc4.png";